import classNames from 'classnames';
import React, { FC, ChangeEvent } from 'react';

import { FieldWrapper, FieldWrapperProps } from '../FieldWrapper';

import PasswordVisibilityToggle from 'pages/auth/components/PasswordVisibilityToggle';
import { usePasswordVisibility } from 'hooks';

type TextFieldProps = FieldWrapperProps & {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  name?: string;
  value?: string;
  placeholder?: string;
  type?: string | undefined;
  maxLength?: number;
  labelClassName?: string;
  inputClassName?: string;
};

const TextField: FC<TextFieldProps> = ({
  value,
  placeholder,
  name,
  type,
  maxLength,
  onChange,
  onFocus,
  onBlur,
  isDisabled,
  inputClassName,
  className,
  ...fieldWrapperProps
}) => {
  const { isVisible, inputRef, toggleVisibility } = usePasswordVisibility();
  const isPasswordType = type === 'password';
  const inputType = isPasswordType && isVisible ? 'text' : type;

  return (
    <FieldWrapper
      isDisabled={isDisabled}
      className={className}
      {...fieldWrapperProps}
      rightChildren={
        isPasswordType && name ? (
          <PasswordVisibilityToggle
            isVisible={isVisible}
            onToggle={toggleVisibility}
            inputId={name}
          />
        ) : (
          fieldWrapperProps.rightChildren
        )
      }
    >
      <input
        ref={inputRef}
        id={name}
        name={name}
        value={isDisabled && !value ? 'Unissued' : value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={isDisabled}
        type={inputType}
        maxLength={maxLength}
        className={classNames(
          'w-full focus:outline-none bg-inherit',
          isDisabled && !value && 'text-[#C4CBDD]',
          inputClassName,
        )}
      />
    </FieldWrapper>
  );
};

export default TextField;
